import api from '../../utils/api'
import apiSubmissionError from '../../utils/apiSubmissionError'

export const getSurveysApi = (params) => api.get('/managers/surveys', { params })
export const getSurveyByIdApi = (id) => api.get(`/managers/surveys/${id}`)
export const deleteSurveyByIdApi = (id) => api.delete(`/managers/surveys/${id}`)
export const createSurveyApi = (data) => api.post(`/managers/surveys`, data).catch(apiSubmissionError)
export const updateSurveyApi = (id, data) => api.put(`/managers/surveys/${id}`, data).catch(apiSubmissionError)
